/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import Alert from "./Alert";
import BaseCom from "./BaseCom";
import DataTable from "./DataTable";
import LoadingAlert from "./LoadingAlert";
import { withParamsAndNavigate } from "./WithParamsAndNavigate";
import { qreq } from "../shared/qrequest";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as fa from '@fortawesome/free-solid-svg-icons'
import Globals from "../shared/Globals";
import { SidebarGlobal } from "./_Sidebar";
import Paging from "./Paging";
import Auth from "../shared/Auth";
import FormInput from "./FormInput";
import { Modal } from "react-bootstrap";
import Icon from "./Icon";

class Invoices extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            query: {
                page: props.params.page ?? 1,
                qfilters: {},
                search: null
            },
            filters: {},
            loaded: false,
            loading: false,
            list: [],
            req: {}
        };
        this.load = this.load.bind(this);
        this.onFilter = this.onFilter.bind(this);
    }

    componentDidMount() {
        this.load();
        SidebarGlobal.setSubNav(<><div className="btn-group">
            <Link to="/invoice/new" className="btn btn-primary"><FontAwesomeIcon icon={fa.faPlus} /> <span className="d-none d-md-inline">New Invoice</span></Link>
        </div></>);
    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.params.page !== this.props.params.page) {
            this.setState({ query: { ...this.state.query, page: this.props.params.page || 1 } });
        }
        if (prevState.query !== this.state.query) {
            if (this.state.query)
                this.load();
        }
    }

    dateFilter(filters, varNames, val) {
        var n = 0;
        if (val) {
            varNames.forEach(i => {
                filters[i] = val[n];
                n++;
            });
        }
        else {
            varNames.forEach(i => {
                delete filters[i];
            });
        }
    }

    onFilter(col) {
        var filters = { ...this.state.filters };

        if (col.filter.filter === 'invoicedate') this.dateFilter(filters, ['InvoideStartDate', 'InvoiceEndDate'], col.filter.value);
        else {
            if (col.filter.value)
                filters[col.filter.filter] = col.filter.value;
            else
                delete filters[col.filter.filter];
        }
        var query = { ...this.state.query, qfilters: filters };
        this.setState({ filters: filters, query: query });
    }

    load(query) {
        if (!query)
            query = this.state.query;
        this.setState({ loading: true });
        qreq.post('/api/invoice/list', query, j => {
            if (j.list) {
                this.setState({ list: j.list, pageCount: j.pageCount, totalCount: j.totalCount });
            }
            else if (j.errorCode !== 0) {
                this.setState({ errorMessage: j.errorMessage });
            }
            this.setState({ loaded: true, loading: false });
        }, () => {
            this.setState({ loaded: true, loading: false, errorMessage: 'Unknown error ocurred.' });
        });
    }

    search = (v) => {
        let query = { ...this.state.query, search: v };
        this.setState({ query: query });
    }

    sendPaymentRequest = async (e) => {
        e?.preventDefault();
        this.setState({ submitting: true });
        try {
            let j = await qreq.postAsync('/api/payment/request/send', this.state.req);
            if (j.item) {
                this.setState({ showSendPaymentRequest: false });
                this.success('Email sent!');
            }
            else {
                this.alert(j.errorMessage);
            }
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
        this.setState({ submitting: false });
    }

    render() {
        const header = (<h1>Invoice</h1>);

        if (!this.state.loaded)
            return (<div className="container-fluid">{header}<LoadingAlert /></div>);

        if (this.state.errorMessage)
            return <Alert type="danger" icon="ExclamationTriangle" message={this.state.errorMessage} />

        const columns = [
            { icon: 'Pencil', link: '/invoice/edit/:id', tooltip: 'Edit Invoice' },
            { icon: 'FilePdf', tooltip: 'Download Invoice', onClick: obj => { window.open(Globals.serverUrl + '/api/invoice/pdf/' + obj.iid); } },
            {
                icon: 'PaperPlane', tooltip: 'Send Payment Request', onClick: obj => this.setState({
                    showSendPaymentRequest: true, req:
                    {
                        invoiceID: obj.id
                    },
                    selectedInvoice: obj
                })
            },
            { name: 'iid', title: 'ID', link: '/invoice/edit/:id', tooltip: 'Edit Invoice', className: 'd-none d-md-table-cell' },
            { name: 'accountName', title: 'Account', className: 'd-none d-md-table-cell' },
            { name: 'invoiceDate', title: 'Invoice Date', link: '/invoice/edit/:id', tooltip: 'Edit Invoice', format: 'date', className: 'd-none d-md-table-cell' },
            { name: 'dueDate', title: 'Due Date', format: 'date', link: '/invoice/edit/:id', tooltip: 'Edit Invoice' },
            {
                name: 'status', title: 'Status', valueFunc: i => {
                    if (i.isPaid)
                        return 'Paid';
                    return 'Pending';
                }
            }
        ];

        if (this.state.MODEL === 'WMS')
            columns.splice(4, 0, { name: 'patientName', title: 'Patient' });

        if (Auth.hasRole('!'))
            columns.splice(1, 0, { icon: 'Trash', tooltip: 'Delete Invoice', onClick: obj => { if (window.confirm('Are you sure you want to delete this invoice?')) { qreq.post('/api/invoice/delete', { id: obj.id }, () => { this.load(); }); } } });

        return <div className="container-fluid">
            {header}
            <div>
                <FormInput
                    model={this.state.query}
                    name="search"
                    type="text"
                    onChange={this.search}
                    label="Search..."
                    labelAsPlaceholder
                />
            </div>
            <DataTable columns={columns} data={this.state.list} loading={this.state.loading} totalCount={this.state.totalCount} showFilters={false} onFilter={this.onFilter} filters={[
                { name: 'invoiceDate', title: 'Invoice Date', filter: 'invoicedate', type: 'daterange' }
            ]} />
            <div className="card-body">
                <Paging baseLoc="/invoice/list/page/" pageCount={this.state.pageCount} currentPage={this.state.query?.page} onPageClick={(e) => this.setState({ loading: true })} />
            </div>





            <Modal show={this.state.showSendPaymentRequest} onHide={() => this.setState({ showSendPaymentRequest: false })}>
                <Modal.Header>
                    <Modal.Title>Payment Request</Modal.Title>
                </Modal.Header>
                <form onSubmit={this.sendPaymentRequest}>
                    <Modal.Body>
                        <FormInput model={this.state.req} name="name" label="Name" type="text" placeholder="John Doe" required />
                        <FormInput model={this.state.req} name="email" label="Email" type="email" placeholder="example@udhs.net" required />
                        <p className="text-muted">Who are you sending this payment request to?</p>
                        <p><i>Payment request expires in 7 days if not processed.</i></p>
                        <p>The payment request is for amount: <strong>{Globals.formatCurrency(this.state.selectedInvoice?.balanceDue)}</strong></p>
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="submit" className="btn btn-success btn-lg" disabled={this.state.submitting}><Icon icon="faPaperPlane" /> Send</button>
                        <button type="button" className="btn btn-secondary btn-lg" onClick={() => this.setState({ showSendPaymentRequest: false })}>
                            Cancel
                        </button>
                    </Modal.Footer>
                </form>
            </Modal>




        </div>;
    }
}

export default withParamsAndNavigate(Invoices);